import Flex from '@vromo/ui/components/Flex';
import Modal from '@vromo/ui/components/Modal';
import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { FleetCoverageDetails } from '../../interfaces';
import styles from './fleetCoverageDetailsModal.style';

const convertToString = (prev: string, curr: string, index: number) =>
    prev + (index === 0 ? '' : ', ') + curr;

interface Props {
    isShowingDetails: boolean;
    detailsItem: FleetCoverageDetails | null;
    onRequestClose: () => void;
}

const FleetCoverageDetailsModal = ({ isShowingDetails, detailsItem, onRequestClose }: Props) => {
    const { t } = useTranslation();

    const coveredZipCodes = detailsItem?.coveredZipCodeArray.reduce(convertToString, '');

    const uncoveredZipCodes = detailsItem?.uncoveredZipCodeArray.reduce(convertToString, '');

    return (
        <Modal
            style={{ content: { width: '60%' } }}
            isOpen={isShowingDetails}
            onRequestClose={onRequestClose}>
            <Flex direction="column" horizontal="left">
                <Flex>
                    <p style={styles.overlayTitle as CSSProperties}>{`${t(
                        'findFleets.fleetName'
                    )}:`}</p>
                    <p style={styles.restaurantTitle as CSSProperties}>{detailsItem?.name}</p>
                </Flex>
                <span style={styles.zipCodeTitle}>{`${detailsItem?.coveredZipCodeArray.length} ${t(
                    'findFleets.zipCodesCovered'
                )}`}</span>
                <div style={styles.scrollContainer as CSSProperties}>
                    <span style={styles.overlayZipCodeList}>{coveredZipCodes}</span>
                </div>
                <span style={styles.zipCodeTitle}>{`${
                    detailsItem?.uncoveredZipCodeArray.length
                } ${t('findFleets.zipCodesNotCovered')}`}</span>
                <div style={styles.scrollContainer as CSSProperties}>
                    <span style={styles.overlayZipCodeList}>{uncoveredZipCodes}</span>
                </div>
            </Flex>
        </Modal>
    );
};

export default FleetCoverageDetailsModal;
